/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferralCodeMetadata } from './ReferralCodeMetadata';
import {
    ReferralCodeMetadataFromJSON,
    ReferralCodeMetadataFromJSONTyped,
    ReferralCodeMetadataToJSON,
} from './ReferralCodeMetadata';

/**
 * 
 * @export
 * @interface ReferralCodeValidationResultMetadata
 */
export interface ReferralCodeValidationResultMetadata {
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeValidationResultMetadata
     */
    sender_name: string;
}

/**
 * Check if a given object implements the ReferralCodeValidationResultMetadata interface.
 */
export function instanceOfReferralCodeValidationResultMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sender_name" in value;

    return isInstance;
}

export function ReferralCodeValidationResultMetadataFromJSON(json: any): ReferralCodeValidationResultMetadata {
    return ReferralCodeValidationResultMetadataFromJSONTyped(json, false);
}

export function ReferralCodeValidationResultMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralCodeValidationResultMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sender_name': json['sender_name'],
    };
}

export function ReferralCodeValidationResultMetadataToJSON(value?: ReferralCodeValidationResultMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sender_name': value.sender_name,
    };
}

